import apiClient from '@/api/client'
import type { ApiResponse } from '@/types/api'
import type { User } from '@/types/auth'
import type { UpdateProfilePayload, UsernameFormData } from '../types'

export const profileApi = {
  updateProfile: (data: UpdateProfilePayload) =>
    apiClient.patch<ApiResponse<User>>('/users/me', data),

  updateUsername: (data: UsernameFormData) =>
    apiClient.patch<ApiResponse<User>>('/users/me/username', data),

  uploadAvatar: (file: File) => {
    const form = new FormData()
    form.append('avatar', file)
    return apiClient.post<ApiResponse<{ avatar_url: string }>>('/users/me/avatar', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },

  deleteAccount: () => apiClient.delete<void>('/users/me'),
}
